exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2tkMhffbFx1KhmJpJXm0Mw{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;text-decoration:none;width:100%}._3n_maJhkVFUbMRUnOnMh53{color:#4a4a4a;margin-bottom:.35714rem;white-space:nowrap}._2Y9u3fQIbGAGVrxIBTtVu_{color:#fff;font-size:.85714rem;letter-spacing:.07143rem;padding:0 .35714rem;text-decoration:none;text-transform:uppercase;white-space:nowrap}._2Y9u3fQIbGAGVrxIBTtVu_:hover{color:#fff}._2vHTKHJKKFtA58cmmdFyjM{background-color:#74d17f}.Iwe1ANbXkRvPx0uNhPdcM{background-color:#f7932d}._22N-1if6DBPXNyfxeffAEV{background-color:#a4a4a4}._21HDSvPWnB_r3WCOuI-r8G{white-space:nowrap}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"cell": "_2tkMhffbFx1KhmJpJXm0Mw",
	"cell_label": "_3n_maJhkVFUbMRUnOnMh53",
	"cell_status": "_2Y9u3fQIbGAGVrxIBTtVu_",
	"cell_status_new": "_2vHTKHJKKFtA58cmmdFyjM",
	"cell_status_inprogress": "Iwe1ANbXkRvPx0uNhPdcM",
	"cell_status_complete": "_22N-1if6DBPXNyfxeffAEV",
	"header": "_21HDSvPWnB_r3WCOuI-r8G"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/WritingAssignment/SpinListView/style.postcss
// module id = 1832
// module chunks = 0